<template>
  <div class="dashboard-block">
    <h2>{{ $t('Shortlist Used') }}
      <a  v-if="editing"
          data-toggle="modal"
          data-target="#modal-add-talent"
          data-backdrop="static"
          class="btn btn-sm pull-right">
        <i class="fa fa-plus"></i>
        <template>Add {{ $starLabelPlural | sentenceCase }}</template>
      </a>
    </h2>
    <div class="shortlist-backing-admin">
      <div v-if="bookingHasNoShortlistedTalent" class="p-sm text-center">
        There are no {{ $t('shortlisted stars') }}.
      </div>
      <div v-else class="shortlist row">
        <booking-search-details-list-item-admin
          v-for="user in bookingShortlistedTalent"
          :key="user.id"
          :user="user"/>
      </div>
    </div>
  </div>
</template>

<script>
import { helpers } from 'mixins/bookings'
import BookingSearchDetailsListItemAdmin from './BookingSearchDetailsListItemAdmin'
import {mapState} from 'vuex'

export default {
  mixins: [helpers],

  computed: {
    ...mapState('editing', ['editing'])
  },

  components: {
    BookingSearchDetailsListItemAdmin
  },

  props: {
    booking: {
      type: Object,
      required: true
    }
  }
}
</script>
